import { CustomFilterMeta } from '@src/main/modules/messages/ui/mailbox/views/mailbox/mailbox.types';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useMemo } from 'react';

const createBaseFilters = (startDate: Date | null, endDate: Date | null): CustomFilterMeta => ({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  subject: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  sendBy: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  message: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  recipients: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  sendDate: sendDateFilter(startDate, endDate),
});

const sendDateFilter = (
  startDate: Date | null,
  endDate: Date | null,
): CustomFilterMeta['sendDate'] => ({
  operator: FilterOperator.AND,
  constraints: [
    {
      value: [startDate, endDate],
      matchMode: FilterMatchMode.BETWEEN,
    },
  ],
});

export const useInboxFilters = (startDate: Date | null, endDate: Date | null) =>
  useMemo(
    () => ({
      ...createBaseFilters(startDate, endDate),
    }),
    [startDate, endDate],
  );

export const useOutboxFilters = (
  startDate: Date | null,
  endDate: Date | null,
): CustomFilterMeta => ({
  ...createBaseFilters(startDate, endDate),
  initDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_AFTER }],
  },
  endDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_BEFORE }],
  },
});
